/* Shared between the landing page (App.js) and any sub-route (HelpPage.js)
   so the header never drifts out of sync between pages. Items without a
   `route` scroll to a same-id section on the landing page. */
export const NAV_LINKS = [
  { id: 'problem', label: 'Why BulandiPe' },
  { id: 'product', label: 'Platform' },
  { id: 'how-it-works', label: 'How It Works' },
  { id: 'institutions', label: 'For Institutions' },
  { id: 'faq', label: 'FAQ' },
  { id: 'help', label: 'Help', route: '/help' },
];
